import { http } from '@/api/http';
const config = require('@/config');

export default {
    //图像统计
    getImageStatisticByType(data) {
        return http.get('/api/ImageStatistic/ByType', data);
    },
    getImageStatisticByKnowledge(data) {
        return http.get('/api/ImageStatistic/ByKnowledge', data, {contentType: 'form'});
    },
    getImageStatisticByAngle(data) {
        return http.get('/api/ImageStatistic/ByAngle', data, {contentType: 'form'});
    },
    getImageStatisticByUseCount(data) {
        return http.get('/api/ImageStatistic/ByUseCount', data, {contentType: 'form'});
    },
    //考题统计
    getTopicStatisticsByType(data) {
        return http.get('/api/TopicStatistics/ByType', data);
    },
    getTopicStatisticsByDifficulty(data) {
        return http.get('/api/TopicStatistics/ByDifficulty', data);
    },
    getTopicStatisticsByKnowLedge(data) {
        return http.get('/api/TopicStatistics/ByKnowLedge', data);
    },
    getTopicStatisticsUpLoadCount(data) {
        return http.get('/api/TopicStatistics/UpLoadCount', data);
    },
    getTopicStatisticsGetTopicListAsync(data) {
        return http.get('/api/TopicStatistics/Query', data);
    },
    //考试统计
    getExamListAsync(data) {
        return http.get('/api/ExamStatistics/Query', data);
    },
    getExamDetailsAsync(data) {
        return http.get('/api/ExamStatistics/Detail', data);
    },
    getScoreRankAsync(data) {
        return http.get('/api/ExamStatistics/Top10Rank', data);
    },
    getScoreRangeAsync(data) {
        return http.get('/api/ExamStatistics/ScoreRange', data);
    },
    getExamTopicsAsync(data) {
        return http.get('/api/ExamStatistics/Topics', data);
    },
    getExamReportAsync(data) {
        return http.get('/api/ExamStatistics/ReportCardItems', data);
    },
    getExamReportCard(data) {
        return http.get('/api/ExamStatistics/ReportCard', data);
    },
    getExamStatusMenu() {
        return http.get(`/api/Dropdown/${'ExamStatus'}`);
    },
    //考试 知识点错误率统计
    getExamKnowErrorRate(data){
        return http.get('/api/ExamStatistics/KnowledgeErrorRate', data);
    },
    //考试 知识点错误率统计--学员
    getExamKnowErrorRateByUser(data){
        return http.get('/api/ExamStatistics/KnowledgeErrorRateByUser', data);
    },

    // 考试，相似试卷
    getExamSimilarList(processID, num) {
        return http.get(`/api/Exam/ExamMonitor/${processID}/${num}`,{}, { timeout: 120000, noShowError: true });
    },
    getExamSimilarDetail(processID, data) {
        return http.get(`/api/Exam/ExamMonitorDetail/${processID}`, data);
    },

    // 导出成绩单
    exportExamReportCard(data) {
        return http.get('/exportapi/WordExport/ExamArchiveExport', data);
    },
    //证书统计
    getCertificateByOrgAsync(data) {
        return http.get('/api/CertificateStatistics/ByOrgAsync', data);
    },
    //资源统计
    getResourceByType(data) {
        return http.get('/api/ResourceStatistics/ByType', data);
    },
    getResourceUpLoadCount(data) {
        return http.get('/api/ResourceStatistics/UpLoadCount', data);
    },
    //课件统计
    getCourseWareByType(data) {
        return http.get('/api/CoursewareStatistics/ByType', data);
    },
    getCourseWareUpLoadCount(data) {
        return http.get('/api/CoursewareStatistics/UpLoadCount', data);
    },
    getCourseWareUsedTimes(data) {
        return http.get('/api/CoursewareStatistics/UsedTimes', data);
    },
    getCourseWareByKnowLedge(data) {
        return http.get('/api/CoursewareStatistics/ByKnowLedge', data);
    },
    //培训统计
    getTrainExamMemberQuery(data) {
        return http.get('/api/TrainingOnlineStatistics/ExamMemberQuery', data);
    },
    getTrainStudyMemberQuery(data) {
        return http.get('/api/TrainingOnlineStatistics/StudyMemberQuery', data);
    },
    getMockExamMemberQuery(data) {
        return http.get('/api/TrainingOnlineStatistics/MockExamMemberQuery', data);
    },
    getCustomMemberQuery(data) {
        return http.get('/api/TrainingOnlineStatistics/CustomizeMemberQuery', data);
    },
    getTrainGetProcessExamInfo(data) {
        return http.get('/api/TrainingOnlineStatistics/ProcessExamStatus', data);
    },
    getTrainGetProcessStudyInfo(data) {
        return http.get('/api/TrainingOnlineStatistics/ProcessStudyStatus', data);
    },
    getTrainGetProcessMockInfo(data) {
        return http.get('/api/TrainingOnlineStatistics/ProcessMockExamStatus', data);
    },
    getTrainGetCustomInfo(data) {
        return http.get('/api/TrainingOnlineStatistics/ProcessCustomizeStatus', data);
    },

    getTrainStatsExport(data) {
        return http.get('/api/Export/Excel/TrainingOnlineStatisticsAsync', data);
    },
    getTrainStatsExportStatus(data) {
        return http.get('/api/Export/Excel/TrainingOnlineAsyncExportStatus', data);
    },

    //离线培训详情
    getTrainOfflineStatistics(id){
        return http.get('/api/TrainingOfflineStatistics/' + id);
    },
    getTrainSurveyPaper(planID) {
        return http.get(`/api/SurveyStatistics/Statistics/${planID}`);
    },

    //一所图像统计
    getFiscanImageStatistic(data) {
        return http.get('/api/stats/fiscan-image-study/report', data);
    },
    getFiscanImageDetailStatistic(id,data){
        return http.get('/api/stats/fiscan-image-study/report/' + id,data);
    },
    //威视图像统计
    getNuctechImageStatistic(data) {
        return http.get('/api/stats/nuctech-image-study/report', data);
    },
    getNuctechImageDetailStatistic(id,data){
        return http.get('/api/stats/nuctech-image-study/report/' + id,data);
    },

    //直播统计
    getLivingStatistic(data) {
        return http.get('/api/live/statistics/Query', data);
    },
    //获取直播详情
    getLivingDetailStatistic(id){
        return http.get('/api/live/statistics/GetLiveRecord/' + id);
    },
    //获取用户观看记录
    getLivingUserStatistic(id,data){
        return http.get(`/api/live/statistics/GetUserViewRecord/${id}`,data);
    },
    //获取用户观看详情
    getLivingUserDetailStatistic(id,userId){
        return http.get(`/api/live/statistics/GetViewRecordDetail/${id}/${userId}`);
    },
    //获取用户聊天记录
    getLivingCommentStatistic(id,data){
        return http.get(`/api/live/statistics/GetLiveCommnt/${id}`,data);
    },
    // 评论数量统计
    getLiveTopComment(id,data){
        return http.get('/api/live/statistics/GetTopCommnt/' + id,data);
    },
    // 观看时长统计
    getLiveTopViewers(id,data){
        return http.get('/api/live/statistics/GetTopViewers/' + id,data);
    },

    // 学分统计
    getCredit(data) {
        return http.get('/api/Credit/Query', data);
    },
    getCreditDetail(id, data) {
        return http.get(`/api/Credit/${id}`, data);
    },
    getCreditOrgs(data) {
        return http.get(`/api/Credit/CreditComparison`, data);
    },

    // 理论练习统计
    getTheroyExcise(data) {
        return http.get('/api/TheoryIStudy/GetTheoryStudyQuery', data);
    },
    getTheroyExciseDetail(id, data) {
        return http.get(`/api/TheoryIStudy/UserQuery/${id}`, data);
    },
    // 理论练习统计
    getImageExcise(data) {
        return http.get('/api/ImageIStudy/GetImageStudyQuery', data);
    },
    getImageExciseDetail(id, data) {
        return http.get(`/api/ImageIStudy/UserQuery/${id}`, data);
    },

    /**
     * 大数据看板大屏
     */
    // 总人数
    getMonitorCount() {
        return http.get(`${config.wsURL}/api/totalUser`);
    },
    // 学分排行
    getMonitorCreditRank() {
        return http.get(`/api/Dashboard/Index/CreditByUserRank`);
    },
    // 学分排行（按机构）
    getMonitorCreditOrgRank() {
        return http.get(`/api/Credit/OrgComparisonDashboard`);
    },
    // 资源数
    getMonitorResourceOverview() {
        return http.get(`/api/Dashboard/Index/ResoureOverview`);
    },
    // 各个环节总使用人次
    getMonitorOverview() {
        return http.get(`/api/Dashboard/Index/DashboardOverview`);
    },
    // 资源上传者排行
    getMonitorResourceRank() {
        return http.get(`/api/Dashboard/Index/ResoureRank`);
    },
    // 打卡签到统计
    checkinStatistics(data) {
        return http.get(`/api/stats/online-checkin/query`, data);
    }
};
